/**
 * Canonical manuscript quotes are straight ASCII: " (U+0022) and ' (U+0027).
 * macOS WKWebView / Safari "Smart Quotes" otherwise insert “ ” ‘ ’.
 */

const DOUBLE_QUOTE_CHARS = "[\u201C\u201D\u201E\u201F\u00AB\u00BB\u2033\u2036\u301D\u301E\u301F\uFF02]";
const SINGLE_QUOTE_CHARS = "[\u2018\u2019\u201A\u201B\u2039\u203A]";
const DOUBLE_QUOTE_VARIANTS = new RegExp(DOUBLE_QUOTE_CHARS, "g");
const SINGLE_QUOTE_VARIANTS = new RegExp(SINGLE_QUOTE_CHARS, "g");
const HAS_TYPOGRAPHIC_QUOTES = new RegExp(`${DOUBLE_QUOTE_CHARS}|${SINGLE_QUOTE_CHARS}`);

export function normalizeQuotesInText(text: string): string {
  if (typeof text !== "string" || text.length === 0) return text;
  DOUBLE_QUOTE_VARIANTS.lastIndex = 0;
  SINGLE_QUOTE_VARIANTS.lastIndex = 0;
  return text.replace(DOUBLE_QUOTE_VARIANTS, '"').replace(SINGLE_QUOTE_VARIANTS, "'");
}

export function textHasTypographicQuotes(text: string): boolean {
  if (typeof text !== "string" || text.length === 0) return false;
  return HAS_TYPOGRAPHIC_QUOTES.test(text);
}

/** Walk TipTap JSON and replace quote variants in every text node. */
export function normalizeQuotesInTipTapContent<T>(node: T): T {
  if (!node || typeof node !== "object") return node;
  const value = node as { type?: string; text?: string; content?: unknown[] };
  if (value.type === "text" && typeof value.text === "string") {
    return { ...value, text: normalizeQuotesInText(value.text) } as T;
  }
  if (Array.isArray(value.content)) {
    return {
      ...value,
      content: value.content.map((child) => normalizeQuotesInTipTapContent(child)),
    } as T;
  }
  return node;
}
